import styled from 'styled-components';

export const LoginFormPageWrapper = styled.div`
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 70px 20px;
`;

export const LoginFormWrapper = styled.div`
  max-width: 325px;
  width: 100%;
  border-radius: 3px;
  background-color: #fff;
`;

export const LoginFormInputWrapper = styled.div`
  width: 100%;
  position: relative;
  padding-top: 1.1em;
  background-color: #fff;
  box-sizing: border-box;
  display: flex;
  justify-content: center;

  .input {
    width: 304px;
    border-radius: 3px;
  }
`;

export const LoginFormButtonWrapper = styled.div`
  padding: 1em 0;
  width: 100%;
  background-color: #fff;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
  justify-content: center;
  box-sizing: border-box;
`;

export const LoginFormButton = styled.button`
  border: none;
  background-color: #fff;
  border: 1px solid ${({ theme }) => theme.primary};
  padding: 15px 131px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.primary};
  color: #fff;
  display: block;
  margin: 0 auto;
  position: relative;
  cursor: pointer;
  font-size: 15px;
  font-weight: normal;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);

  &:hover {
    background-color: #fff;
    color: ${({ theme }) => theme.primary};
  }

  &:disabled {
    background-color: #555;
    cursor: not-allowed;
    border: none;
    &:hover {
      color: #fff;
    }
  }
`;

export const RegisterText = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;

  a {
    text-decoration: none;
    color: #7e8185;

    &:hover {
      color: ${({ theme }) => theme.primary};
    }
  }
`;

export const ReCaptchaWrapper = styled.div`
  display: flex;
  margin-top: 15px;
  justify-content: center;
`;

export const Separator = styled.div`
  max-width: 325px;
  width: 100%;
  border-top: 2px solid #ccc;
  margin-top: 50px;
`;

export const CreatedAccount = styled.button`
  /* base */
  display: flex;
  margin-top: 20px;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 2px solid ${({ theme }) => theme.primary};
  background: transparent;
  color: ${({ theme }) => theme.primary};
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;

  &:visited {
    color: ${({ theme }) => theme.primary};
  }

  &:hover,
  &:hover:visited {
    color: ${({ theme }) => theme.primary};
    opacity: 0.8;
  }

  &:hover svg {
    color: ${({ theme }) => theme.primary};
    opacity: 0.8;
  }

  svg {
    font-size: 20px;
    transition: color 0.2s ease;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.primary};
    opacity: 0.8;
    outline-offset: 2px;
  }
`;

export const TwoFactorWrapper = styled.div`
  max-width: 325px;
  width: 100%;
  border-radius: 3px;
  background-color: #fff;
  padding: 30px 20px;
  text-align: center;
`;

export const TwoFactorTitle = styled.h2`
  font-size: 20px;
  color: #333;
  margin-bottom: 8px;
`;

export const TwoFactorSubtitle = styled.p`
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
`;

export const CodeInputContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 16px;
`;

export const CodeInput = styled.input`
  width: 44px;
  height: 52px;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  outline: none;
  transition: border-color 0.2s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);

  &:focus {
    border-color: ${({ theme }) => theme.primary};
  }

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

export const CountdownText = styled.p`
  font-size: 13px;
  color: #999;
  margin-bottom: 16px;
`;

export const ResendButton = styled.button<{ disabled?: boolean }>`
  background: none;
  border: none;
  color: ${({ theme, disabled }) => (disabled ? '#ccc' : theme.primary)};
  font-size: 14px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  text-decoration: underline;
  margin-bottom: 12px;

  &:hover {
    opacity: ${({ disabled }) => (disabled ? 1 : 0.8)};
  }
`;

export const ErrorText = styled.p`
  color: #ff4d4f;
  font-size: 13px;
  margin-bottom: 12px;
`;

export const BackToLoginLink = styled.button`
  background: none;
  border: none;
  color: #7e8185;
  font-size: 13px;
  cursor: pointer;
  margin-top: 24px;
  margin-left: 8px;

  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

export const TwoFactorIcon = styled.div`
  font-size: 40px;
  color: ${({ theme }) => theme.primary};
  margin-bottom: 16px;
`;
